const map = {
	"./cs-cz.json": 3635,
	"./da-dk.json": 3188,
	"./de-de.json": 8574,
	"./en.json": 4174,
	"./es-es.json": 5784,
	"./fi-fi.json": 6986,
	"./fr-fr.json": 5476,
	"./it-it.json": 8062,
	"./ja-jp.json": 365,
	"./ko-kr.json": 2623,
	"./nb-no.json": 3763,
	"./nl-nl.json": 6780,
	"./pl-pl.json": 1704,
	"./pt-br.json": 5960,
	"./ru-ru.json": 2490,
	"./sv-se.json": 1911,
	"./tr-tr.json": 7928,
	"./zh-cn.json": 2651,
	"./zh-tw.json": 1587
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7066;